import styled from 'styled-components';
import Flex from './Flex';

export default styled(Flex)`
  width: 100%;
  height: 100%;
`;
